module.exports = __webpack_public_path__ + "img/what-we-sell_0003.c1a0920c.jpg";